import {IOption} from "@pg-design/select-module";

import {OfferType} from "../../offer/types/OfferType";

export const OfferTypeOptions: IOption[] = [
    {
        label: "Mieszkanie",
        value: OfferType.FLAT
    },
    {
        label: "Dom",
        value: OfferType.HOUSE
    },
    {
        label: "Lokal użytkowy",
        value: OfferType.COMMERCIAL
    }
];
import {IOption} from "@pg-design/select-module";

import {OfferType} from "../../offer/types/OfferType";

export const OfferTypeOptions: IOption[] = [
    {
        label: "Mieszkanie",
        value: OfferType.FLAT
    },
    {
        label: "Dom",
        value: OfferType.HOUSE
    },
    {
        label: "Lokal użytkowy",
        value: OfferType.COMMERCIAL
    }
];
